import Resizable from "./component";

export default Resizable;